import React, { forwardRef, useEffect } from "react";
import InputField from "../../../../generic/inputField";
import TocDropdown from "../../../../generic/tocDropdown";
import {getinvAccDet} from "../../../../service/login/loginService"
export const DpTrading = forwardRef((props: any) => {
  useEffect(() => {
    console.log("props", props);
  }, []);
  let invOnlyAcc = getinvAccDet();

  return (
    <>
      <div className="custom--row tradingAccnt dpTradingAcctWrap">
        {props.dpOptions &&
          props.dpOptions.length > 2 &&
          props.selectedAcc.toLowerCase().includes("demat") && (
            <>
              <div
                className={
                  "form-field custom-col custom-col-demat noLeftPAdding"
                }
              >
                <div>
                  <label className="input-label">DP Details</label>
                  <TocDropdown
                    selectedValue={
                      props.dpOptions.length > 0
                        ? props.selectedDp
                        : "Select DP Details"
                    }
                    dropdownOptions={props.dpOptions}
                    onSelect={(val) => {
                      if (val) {
                        if (props.setErrors)
                          props.setErrors({ ...props.errors, dp: "" });
                        props.setSelectedDp(val);
                      }
                    }}
                    isSearchable={false}
                  />
                </div>
                {props.errors && props.errors.dp && (
                  <p className="help_text red">{props.errors.dp}</p>
                )}
              </div>
            </>
          )}
        {props.dpOptions &&
          props.dpOptions.length === 2 &&
          props.selectedAcc.toLowerCase().includes("demat") && !invOnlyAcc && (
            <div className={"form-field custom-col  noLeftPAdding"}>
              <label className="input-label">DP Details</label>

              <InputField
                type="text"
                defaultValue={props.selectedDp}
                onChange={() => {}}
                onBlur={() => {}}
                placeholder=""
                disabled={true}
              />
            </div>
          )}
        {props.selectedAcc.toLowerCase().includes("trading") && !invOnlyAcc && (
          <div
            className={
              "form-field custom-col noLeftPAdding  dpTradingAcctWrap-trade" +
              (props.selectedAcc === "tradingDemat" ? " custom-col-mt-30" : "")
            }
          >
            <label className="input-label">Trading Account</label>

            <InputField
              type="text"
              defaultValue={props.accountCode}
              onChange={() => {}}
              onBlur={() => {}}
              placeholder=""
              disabled={true}
            />
          </div>
        )}

        <div className="custom-col-100">
          <p className="error">{props.errorMsg}</p>
        </div>
        {/* {props.errors && props.errors.dp && (
          <div className="custom-col-100">
            <p className="error">{props.errors.dp}</p>
          </div>
        )} */}
      </div>
    </>
  );
});
